export const webinarDetails: string[] = [
  'Próxima fecha disponible: te la confirmamos apenas te unas al grupo',
  '100% en vivo — cupos limitados por sesión',
  'Por WhatsApp/YouTube — sin costo',
]

export const webinarLearnings: string[] = [
  'Por qué el tiempo solo no cura una ruptura (y qué sí funciona de verdad)',
  'El nivel exacto de consciencia en el que probablemente estás atrapado ahora mismo',
  '2 técnicas de PNL que puedes aplicar esa misma noche para empezar a soltar',
  'Cómo saber si estás listo/a para una relación sana, o si todavía te falta un paso',
]

export interface ConsciousnessLevel {
  name: string
  note: string
  /** Los niveles altos son el destino del webinar. */
  destination: boolean
}

export const consciousnessLevels: ConsciousnessLevel[] = [
  { name: 'Culpa y Vergüenza', note: 'Te castigas buscando qué hiciste mal', destination: false },
  { name: 'Apatía y Dolor', note: 'Apagaste todo para no sentir', destination: false },
  { name: 'Ira y Orgullo', note: 'Tienes razón, pero sigues atado', destination: false },
  { name: 'Coraje y Aceptación', note: 'Empiezas a sostener lo que sientes', destination: true },
  { name: 'Amor y Paz', note: 'Amas sin miedo y sin repetir el patrón', destination: true },
]

export const webinarAudience: string[] = [
  'Hiciste el test y saliste en un nivel donde sientes que sigues "atascado/a"',
  'Sientes que ya pasó tiempo suficiente, pero no logras soltar del todo',
  'Quieres herramientas reales, no solo "frases motivacionales" de redes sociales',
  'Estás listo/a para invertir 60 minutos en ti mismo/a, hoy',
]
